import { render, staticRenderFns } from "./TifRutasSitio.vue?vue&type=template&id=bb4a3aa2"
import script from "./TifRutasSitio.vue?vue&type=script&lang=js"
export * from "./TifRutasSitio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports